import type { Carry, Pipe } from '~/lib/router/Pipeline';

export default function useMiddleware(handler: Carry): Pipe {
    return {
        handle: handler,
    };
}
